import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowUpRight, ArrowDownRight, ArrowLeftRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const BINANCE_REFERRAL = "https://www.binance.com/register?ref=KXMN4JF5";

const COIN_MAP = {
  bitcoin:       { symbol: "BTCUSDT",    ticker: "BTC",    name: "Bitcoin",         coingecko: "bitcoin" },
  ethereum:      { symbol: "ETHUSDT",    ticker: "ETH",    name: "Ethereum",        coingecko: "ethereum" },
  bnb:           { symbol: "BNBUSDT",    ticker: "BNB",    name: "BNB",             coingecko: "binancecoin" },
  xrp:           { symbol: "XRPUSDT",    ticker: "XRP",    name: "XRP",             coingecko: "ripple" },
  solana:        { symbol: "SOLUSDT",    ticker: "SOL",    name: "Solana",          coingecko: "solana" },
  cardano:       { symbol: "ADAUSDT",    ticker: "ADA",    name: "Cardano",         coingecko: "cardano" },
  dogecoin:      { symbol: "DOGEUSDT",   ticker: "DOGE",   name: "Dogecoin",        coingecko: "dogecoin" },
  tron:          { symbol: "TRXUSDT",    ticker: "TRX",    name: "TRON",            coingecko: "tron" },
  avalanche:     { symbol: "AVAXUSDT",   ticker: "AVAX",   name: "Avalanche",       coingecko: "avalanche-2" },
  polkadot:      { symbol: "DOTUSDT",    ticker: "DOT",    name: "Polkadot",        coingecko: "polkadot" },
  chainlink:     { symbol: "LINKUSDT",   ticker: "LINK",   name: "Chainlink",       coingecko: "chainlink" },
  litecoin:      { symbol: "LTCUSDT",    ticker: "LTC",    name: "Litecoin",        coingecko: "litecoin" },
  polygon:       { symbol: "POLUSDT",    ticker: "POL",    name: "Polygon",         coingecko: "matic-network" },
  uniswap:       { symbol: "UNIUSDT",    ticker: "UNI",    name: "Uniswap",         coingecko: "uniswap" },
  near:          { symbol: "NEARUSDT",   ticker: "NEAR",   name: "NEAR Protocol",   coingecko: "near" },
  atom:          { symbol: "ATOMUSDT",   ticker: "ATOM",   name: "Cosmos",          coingecko: "cosmos" },
  arbitrum:      { symbol: "ARBUSDT",    ticker: "ARB",    name: "Arbitrum",        coingecko: "arbitrum" },
  optimism:      { symbol: "OPUSDT",     ticker: "OP",     name: "Optimism",        coingecko: "optimism" },
  injective:     { symbol: "INJUSDT",    ticker: "INJ",    name: "Injective",       coingecko: "injective-protocol" },
  sui:           { symbol: "SUIUSDT",    ticker: "SUI",    name: "Sui",             coingecko: "sui" },
  aptos:         { symbol: "APTUSDT",    ticker: "APT",    name: "Aptos",           coingecko: "aptos" },
  filecoin:      { symbol: "FILUSDT",    ticker: "FIL",    name: "Filecoin",        coingecko: "filecoin" },
  stellar:       { symbol: "XLMUSDT",    ticker: "XLM",    name: "Stellar",         coingecko: "stellar" },
  vechain:       { symbol: "VETUSDT",    ticker: "VET",    name: "VeChain",         coingecko: "vechain" },
  algorand:      { symbol: "ALGOUSDT",   ticker: "ALGO",   name: "Algorand",        coingecko: "algorand" },
  sandbox:       { symbol: "SANDUSDT",   ticker: "SAND",   name: "The Sandbox",     coingecko: "the-sandbox" },
  mana:          { symbol: "MANAUSDT",   ticker: "MANA",   name: "Decentraland",    coingecko: "decentraland" },
  aave:          { symbol: "AAVEUSDT",   ticker: "AAVE",   name: "Aave",            coingecko: "aave" },
  render:        { symbol: "RENDERUSDT", ticker: "RENDER", name: "Render",          coingecko: "render-token" },
  pepe:          { symbol: "PEPEUSDT",   ticker: "PEPE",   name: "Pepe",            coingecko: "pepe" },
  ton:           { symbol: "TONUSDT",    ticker: "TON",    name: "Toncoin",         coingecko: "the-open-network" },
  "shiba-inu":   { symbol: "SHIBUSDT",   ticker: "SHIB",   name: "Shiba Inu",       coingecko: "shiba-inu" },
  hedera:        { symbol: "HBARUSDT",   ticker: "HBAR",   name: "Hedera",          coingecko: "hedera-hashgraph" },
  "bitcoin-cash":{ symbol: "BCHUSDT",    ticker: "BCH",    name: "Bitcoin Cash",    coingecko: "bitcoin-cash" },
  floki:         { symbol: "FLOKIUSDT",  ticker: "FLOKI",  name: "Floki",           coingecko: "floki" },
  dogwifhat:     { symbol: "WIFUSDT",    ticker: "WIF",    name: "dogwifhat",       coingecko: "dogwifcoin" },
  bonk:          { symbol: "BONKUSDT",   ticker: "BONK",   name: "Bonk",            coingecko: "bonk" },
  jasmy:         { symbol: "JASMYUSDT",  ticker: "JASMY",  name: "JasmyCoin",       coingecko: "jasmycoin" },
  hyperliquid:   { symbol: "HYPEUSDT",   ticker: "HYPE",   name: "Hyperliquid",     coingecko: "hyperliquid" },
  fantom:        { symbol: "SUSDT",      ticker: "S",      name: "Sonic",           coingecko: "fantom" },
  theta:         { symbol: "THETAUSDT",  ticker: "THETA",  name: "Theta Network",   coingecko: "theta-token" },
  eos:           { symbol: "EOSUSDT",    ticker: "EOS",    name: "EOS",             coingecko: "eos" },
  zilliqa:       { symbol: "ZILUSDT",    ticker: "ZIL",    name: "Zilliqa",         coingecko: "zilliqa" },
  kava:          { symbol: "KAVAUSDT",   ticker: "KAVA",   name: "Kava",            coingecko: "kava" },
  pancakeswap:   { symbol: "CAKEUSDT",   ticker: "CAKE",   name: "PancakeSwap",     coingecko: "pancakeswap-token" },
  gala:          { symbol: "GALAUSDT",   ticker: "GALA",   name: "Gala",            coingecko: "gala" },
  "axie-infinity":{ symbol: "AXSUSDT",   ticker: "AXS",    name: "Axie Infinity",   coingecko: "axie-infinity" },
  "the-graph":   { symbol: "GRTUSDT",    ticker: "GRT",    name: "The Graph",       coingecko: "the-graph" },
  quant:         { symbol: "QNTUSDT",    ticker: "QNT",    name: "Quant",           coingecko: "quant-network" },
  immutable:     { symbol: "IMXUSDT",    ticker: "IMX",    name: "Immutable",       coingecko: "immutable-x" },
  stacks:        { symbol: "STXUSDT",    ticker: "STX",    name: "Stacks",          coingecko: "blockstack" },
  maker:         { symbol: "MKRUSDT",    ticker: "MKR",    name: "Maker",           coingecko: "maker" },
  compound:      { symbol: "COMPUSDT",   ticker: "COMP",   name: "Compound",        coingecko: "compound-governance-token" },
  "curve-dao":   { symbol: "CRVUSDT",    ticker: "CRV",    name: "Curve DAO",       coingecko: "curve-dao-token" },
  "1inch":       { symbol: "1INCHUSDT",  ticker: "1INCH",  name: "1inch",           coingecko: "1inch" },
  enjin:         { symbol: "ENJUSDT",    ticker: "ENJ",    name: "Enjin Coin",      coingecko: "enjincoin" },
  chiliz:        { symbol: "CHZUSDT",    ticker: "CHZ",    name: "Chiliz",          coingecko: "chiliz" },
  blur:          { symbol: "BLURUSDT",   ticker: "BLUR",   name: "Blur",            coingecko: "blur" },
  dydx:          { symbol: "DYDXUSDT",   ticker: "DYDX",   name: "dYdX",            coingecko: "dydx" },
  woo:           { symbol: "WOOUSDT",    ticker: "WOO",    name: "WOO Network",     coingecko: "woo-network" },
  band:          { symbol: "BANDUSDT",   ticker: "BAND",   name: "Band Protocol",   coingecko: "band-protocol" },
  ocean:         { symbol: "OCEANUSDT",  ticker: "OCEAN",  name: "Ocean Protocol",  coingecko: "ocean-protocol" },
  ankr:          { symbol: "ANKRUSDT",   ticker: "ANKR",   name: "Ankr",            coingecko: "ankr" },
  skale:         { symbol: "SKLUSDT",    ticker: "SKL",    name: "SKALE",           coingecko: "skale" },
  "lido-dao":    { symbol: "LDOUSDT",    ticker: "LDO",    name: "Lido DAO",        coingecko: "lido-dao" },
  "rocket-pool": { symbol: "RPLUSDT",    ticker: "RPL",    name: "Rocket Pool",     coingecko: "rocket-pool" },
  ape:           { symbol: "APEUSDT",    ticker: "APE",    name: "ApeCoin",         coingecko: "apecoin" },
  gmt:           { symbol: "GMTUSDT",    ticker: "GMT",    name: "STEPN",           coingecko: "stepn" },
  magic:         { symbol: "MAGICUSDT",  ticker: "MAGIC",  name: "Magic",           coingecko: "magic" },
  flux:          { symbol: "FLUXUSDT",   ticker: "FLUX",   name: "Flux",            coingecko: "zelcash" },
  storj:         { symbol: "STORJUSDT",  ticker: "STORJ",  name: "Storj",           coingecko: "storj" },
  arweave:       { symbol: "ARUSDT",     ticker: "AR",     name: "Arweave",         coingecko: "arweave" },
  helium:        { symbol: "HNTUSDT",    ticker: "HNT",    name: "Helium",          coingecko: "helium" },
  iota:          { symbol: "IOTAUSDT",   ticker: "IOTA",   name: "IOTA",            coingecko: "iota" },
  neo:           { symbol: "NEOUSDT",    ticker: "NEO",    name: "NEO",             coingecko: "neo" },
  waves:         { symbol: "WAVESUSDT",  ticker: "WAVES",  name: "Waves",           coingecko: "waves" },
  dash:          { symbol: "DASHUSDT",   ticker: "DASH",   name: "Dash",            coingecko: "dash" },
  zcash:         { symbol: "ZECUSDT",    ticker: "ZEC",    name: "Zcash",           coingecko: "zcash" },
  ontology:      { symbol: "ONTUSDT",    ticker: "ONT",    name: "Ontology",        coingecko: "ontology" },
  ravencoin:     { symbol: "RVNUSDT",    ticker: "RVN",    name: "Ravencoin",       coingecko: "ravencoin" },
  harmony:       { symbol: "ONEUSDT",    ticker: "ONE",    name: "Harmony",         coingecko: "harmony" },
  celo:          { symbol: "CELOUSDT",   ticker: "CELO",   name: "Celo",            coingecko: "celo" },
  icon:          { symbol: "ICXUSDT",    ticker: "ICX",    name: "ICON",            coingecko: "icon" },
  nervos:        { symbol: "CKBUSDT",    ticker: "CKB",    name: "Nervos Network",  coingecko: "nervos-network" },
  klaytn:        { symbol: "KLAYUSDT",   ticker: "KLAY",   name: "Klaytn",          coingecko: "klay-token" },
  convex:        { symbol: "CVXUSDT",    ticker: "CVX",    name: "Convex Finance",  coingecko: "convex-finance" },
  yearn:         { symbol: "YFIUSDT",    ticker: "YFI",    name: "yearn.finance",   coingecko: "yearn-finance" },
  sushi:         { symbol: "SUSHIUSDT",  ticker: "SUSHI",  name: "SushiSwap",       coingecko: "sushi" },
  balancer:      { symbol: "BALUSDT",    ticker: "BAL",    name: "Balancer",        coingecko: "balancer" },
  loopring:      { symbol: "LRCUSDT",    ticker: "LRC",    name: "Loopring",        coingecko: "loopring" },
  mask:          { symbol: "MASKUSDT",   ticker: "MASK",   name: "Mask Network",    coingecko: "mask-network" },
  "ethereum-name-service": { symbol: "ENSUSDT", ticker: "ENS", name: "ENS", coingecko: "ethereum-name-service" },
  sei:           { symbol: "SEIUSDT",    ticker: "SEI",    name: "Sei",             coingecko: "sei-network" },
  "trust-wallet":{ symbol: "TWUSDT",    ticker: "TWT",    name: "Trust Wallet",    coingecko: "trust-wallet-token" },
  jupiter:       { symbol: "JUPUSDT",    ticker: "JUP",    name: "Jupiter",         coingecko: "jupiter-exchange-solana" },
  pyth:          { symbol: "PYTHUSDT",   ticker: "PYTH",   name: "Pyth Network",    coingecko: "pyth-network" },
  worldcoin:     { symbol: "WLDUSDT",    ticker: "WLD",    name: "Worldcoin",       coingecko: "worldcoin-wld" },
  notcoin:       { symbol: "NOTUSDT",    ticker: "NOT",    name: "Notcoin",         coingecko: "notcoin" },
};

const INTERVALS = [
  { label: "1H", value: "1h", limit: 168 },
  { label: "4H", value: "4h", limit: 300 },
  { label: "1D", value: "1d", limit: 500 },
  { label: "1W", value: "1w", limit: 200 },
];

function formatNumber(n) {
  if (!n) return "N/A";
  if (n >= 1e12) return "$" + (n / 1e12).toFixed(2) + "T";
  if (n >= 1e9) return "$" + (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return "$" + (n / 1e6).toFixed(2) + "M";
  return "$" + n.toLocaleString();
}

function formatPrice(price) {
  if (!price) return "N/A";
  if (price < 1) return "$" + price.toFixed(6);
  return "$" + price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function MiniConverter({ ticker, price }) {
  const [cryptoAmount, setCryptoAmount] = useState("1");
  const [usdAmount, setUsdAmount] = useState("");
  const [direction, setDirection] = useState("cryptoToUsd");

  useEffect(() => {
    if (price && direction === "cryptoToUsd") {
      const val = parseFloat(cryptoAmount) || 0;
      setUsdAmount((val * price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }
  }, [price, cryptoAmount, direction]);

  const handleCryptoChange = (e) => {
    setCryptoAmount(e.target.value);
    setDirection("cryptoToUsd");
    const val = parseFloat(e.target.value) || 0;
    if (price) setUsdAmount((val * price).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  };

  const handleUsdChange = (e) => {
    setUsdAmount(e.target.value);
    setDirection("usdToCrypto");
    const val = parseFloat(e.target.value.replace(/,/g, "")) || 0;
    if (price) {
      const crypto = val / price;
      setCryptoAmount(crypto < 1 ? crypto.toFixed(8) : crypto.toFixed(4));
    }
  };

  const swap = () => {
    setDirection(direction === "cryptoToUsd" ? "usdToCrypto" : "cryptoToUsd");
  };

  return (
    <div className="w-full">
      <div className="space-y-2">
        <div className="flex items-center bg-[var(--bg-elevated)] border border-[var(--border-soft)] px-3 py-2 focus-within:border-yellow-400 transition">
          <input
            type="number"
            value={cryptoAmount}
            onChange={handleCryptoChange}
            className="bg-transparent text-[var(--text-primary)] text-sm flex-1 outline-none w-0"
            placeholder="0"
          />
          <span className="font-mono text-xs text-yellow-400 ml-2 flex-shrink-0">{ticker}</span>
        </div>
        <div className="flex justify-center">
          <button onClick={swap} className="text-zinc-500 hover:text-yellow-400 transition">
            <ArrowLeftRight className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center bg-[var(--bg-elevated)] border border-[var(--border-soft)] px-3 py-2 focus-within:border-yellow-400 transition">
          <input
            type="text"
            value={usdAmount}
            onChange={handleUsdChange}
            className="bg-transparent text-[var(--text-primary)] text-sm flex-1 outline-none w-0"
            placeholder="0.00"
          />
          <span className="font-mono text-xs text-[var(--text-tertiary)] ml-2 flex-shrink-0">USD</span>
        </div>
      </div>
      <p className="text-xs text-[var(--text-tertiary)] mt-2 font-mono">
        {"1 " + ticker + " = " + formatPrice(price)}
      </p>
    </div>
  );
}

function MarketStats({ globalData, fearGreed }) {
  const fgi = fearGreed ? parseInt(fearGreed.value) : null;
  const fgiLabel = fearGreed ? fearGreed.value_classification : "N/A";
  const fgiColor = fgi === null ? "#71717a" : fgi >= 60 ? "#22c55e" : fgi >= 40 ? "#facc15" : "#ef4444";
  const btcDom = globalData ? globalData.market_cap_percentage?.btc?.toFixed(1) + "%" : "N/A";
  const totalMktCap = globalData ? formatNumber(globalData.total_market_cap?.usd) : "N/A";
  const totalVol = globalData ? formatNumber(globalData.total_volume?.usd) : "N/A";
  const mktCapChange = globalData ? globalData.market_cap_change_percentage_24h_usd : null;

  const items = [
    { label: "Fear & Greed", value: fgi !== null ? fgi.toString() : "N/A", sub: fgiLabel, subColor: fgiColor },
    { label: "BTC Dominance", value: btcDom, sub: null, subColor: "#71717a" },
    { label: "Total Mkt Cap", value: totalMktCap, sub: mktCapChange ? (mktCapChange > 0 ? "+" : "") + mktCapChange.toFixed(1) + "%" : null, subColor: mktCapChange > 0 ? "#22c55e" : "#ef4444" },
    { label: "24h Vol", value: totalVol, sub: null, subColor: "#71717a" },
  ];

  return (
    <div className="grid grid-cols-4 gap-2 mt-3 pt-3 border-t border-[var(--border-soft)]">
      {items.map((item) => (
        <div key={item.label} className="bg-[var(--bg-elevated)] px-2 py-2 text-center">
          <div className="text-xs font-mono uppercase tracking-widest text-[var(--text-tertiary)] mb-1 leading-tight">{item.label}</div>
          <div className="font-display font-bold text-[var(--text-primary)] text-sm">{item.value}</div>
          {item.sub && (
            <div className="font-mono text-xs mt-1" style={{ color: item.subColor }}>{item.sub}</div>
          )}
        </div>
      ))}
    </div>
  );
}

function BinanceCTA({ name }) {
  const handleClick = () => {
    window.open(BINANCE_REFERRAL, "_blank", "noopener,noreferrer");
  };
  return (
    <div className="mt-10 bg-[var(--bg-panel)] border border-yellow-400/20 p-6 flex flex-col md:flex-row items-center justify-between gap-4">
      <div>
        <p className="font-display font-bold text-[var(--text-primary)] text-lg"></p>
        <p className="text-[var(--text-secondary)] text-sm mt-1"></p>
        <p className="text-zinc-400 text-sm mt-1">Get started on Binance — the world's largest crypto exchange.</p>
      </div>
      <button
        onClick={handleClick}
        className="bg-yellow-400 text-black font-bold uppercase tracking-wide px-6 py-3 hover:bg-yellow-500 transition whitespace-nowrap"
      >
        Trade on Binance
      </button>
    </div>
  );
}

export default function CoinDetail() {
  const { slug } = useParams();
  const coin = COIN_MAP[slug];
  const { theme } = useTheme();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const candleSeriesRef = useRef(null);
  const wsRef = useRef(null);
  const [activeInterval, setActiveInterval] = useState("1d");
  const [livePrice, setLivePrice] = useState(null);
  const [change24h, setChange24h] = useState(null);
  const [marketData, setMarketData] = useState(null);
  const [news, setNews] = useState([]);
  const [chartReady, setChartReady] = useState(false);
  const [chartType, setChartType] = useState("line");
  const [globalData, setGlobalData] = useState(null);
  const [fearGreed, setFearGreed] = useState(null);
  const lineSeriesRef = useRef(null);
  const volumeSeriesRef = useRef(null);

  useEffect(() => {
    if (!coin) return;
    const url = "https://api.coingecko.com/api/v3/coins/" + coin.coingecko + "?localization=false&tickers=false&community_data=false&developer_data=false";
    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        setMarketData(data);
        setLivePrice(data?.market_data?.current_price?.usd);
        setChange24h(data?.market_data?.price_change_percentage_24h);
      })
      .catch(() => {});
  }, [coin]);

  useEffect(() => {
    fetch("https://api.coingecko.com/api/v3/global")
      .then((r) => r.json())
      .then((d) => setGlobalData(d.data))
      .catch(() => {});
    fetch("https://api.alternative.me/fng/")
      .then((r) => r.json())
      .then((d) => setFearGreed(d.data[0]))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!coin) return;
    const catMap = {
      bitcoin: "bitcoin", ethereum: "ethereum", bnb: "altcoins",
      xrp: "altcoins", solana: "altcoins", cardano: "altcoins",
      dogecoin: "altcoins", polygon: "altcoins", litecoin: "altcoins", chainlink: "altcoins",
    };
    api.get("/news?category=" + catMap[slug] + "&limit=4")
      .then((r) => setNews(r.data.slice(0, 3)))
      .catch(() => {});
  }, [slug, coin]);

  useEffect(() => {
    if (!chartRef.current || !coin) return;
    let chart;
    const timer = setTimeout(() => {
      if (!chartRef.current) return;
      import("lightweight-charts").then(({ createChart }) => {
        if (!chartRef.current) return;
        const w = chartRef.current.getBoundingClientRect().width || 600;
        const isDark = document.documentElement.classList.contains("light") === false;
        const bgColor = isDark ? "#0a0a0b" : "#ffffff";
        const textColor = isDark ? "#a1a1aa" : "#52525b";
        const gridColor = isDark ? "#ffffff08" : "#00000008";

        chart = createChart(chartRef.current, {
          width: w,
          height: 380,
          layout: { background: { color: bgColor }, textColor: textColor },
          grid: { vertLines: { color: gridColor }, horzLines: { color: gridColor } },
          crosshair: { mode: 1 },
          rightPriceScale: { borderColor: "#ffffff20" },
          timeScale: { 
            borderColor: "#ffffff20", 
            timeVisible: true, 
            rightOffset: 10,
            barSpacing: 6,
            fixLeftEdge: true,
            fixRightEdge: false,
            lockVisibleTimeRangeOnResize: false,
          },
        });
        if (chartType === "line") {
          const series = chart.addAreaSeries({
            lineColor: "#facc15",
            topColor: "#facc1540",
            bottomColor: "#facc1500",
            lineWidth: 2,
            priceScaleId: "right",
          });
          lineSeriesRef.current = series;
          candleSeriesRef.current = null;
        } else {
          const series = chart.addCandlestickSeries({
            upColor: "#22c55e", downColor: "#ef4444",
            borderUpColor: "#22c55e", borderDownColor: "#ef4444",
            wickUpColor: "#22c55e", wickDownColor: "#ef4444",
            priceScaleId: "right",
          });
          candleSeriesRef.current = series;
          lineSeriesRef.current = null;
        }

        // Volume series
        const volSeries = chart.addHistogramSeries({
          color: "#facc1540",
          priceFormat: { type: "volume" },
          priceScaleId: "volume",
        });
        chart.priceScale("volume").applyOptions({
          scaleMargins: { top: 0.8, bottom: 0 },
        });
        volumeSeriesRef.current = volSeries;
        chartInstance.current = chart;
        setChartReady(true);
        const handleResize = () => {
          if (chartRef.current && chart) {
            chart.applyOptions({ width: chartRef.current.getBoundingClientRect().width });
          }
        };
        window.addEventListener("resize", handleResize);
      });
    }, 300);
    return () => {
      clearTimeout(timer);
      if (chart) chart.remove();
      chartInstance.current = null;
      candleSeriesRef.current = null;
      lineSeriesRef.current = null;
      volumeSeriesRef.current = null;
      setChartReady(false);
    };
  }, [coin, chartType, theme]);

useEffect(() => {
    if (!coin || !chartReady) return;
    const activeSeries = chartType === "line" ? lineSeriesRef.current : candleSeriesRef.current;
    if (!activeSeries) return;

    const int = INTERVALS.find((i) => i.value === activeInterval);

    // For 1D and 1W fetch multiple batches to get more history
    const fetchKlines = async () => {
      try {
        let allData = [];

        if (activeInterval === "1d" || activeInterval === "1w") {
          // Fetch 3 batches going back in time
          const batchSize = 1000;
          let endTime = null;

          for (let batch = 0; batch < 3; batch++) {
            let url = "https://api.binance.com/api/v3/klines?symbol=" + coin.symbol + "&interval=" + activeInterval + "&limit=" + batchSize;
            if (endTime) url += "&endTime=" + endTime;

            const r = await fetch(url);
            const data = await r.json();
            if (!Array.isArray(data) || data.length === 0) break;

            allData = [...data, ...allData];
            endTime = data[0][0] - 1;

            // Small delay to avoid rate limiting
            await new Promise((res) => setTimeout(res, 100));
          }
        } else {
          // For 1H and 4H just fetch one batch
          const url = "https://api.binance.com/api/v3/klines?symbol=" + coin.symbol + "&interval=" + activeInterval + "&limit=" + int.limit;
          const r = await fetch(url);
          allData = await r.json();
        }

        if (!Array.isArray(allData) || allData.length === 0) return;

        // Remove duplicate timestamps
        const seen = new Set();
        allData = allData.filter((d) => {
          const t = Math.floor(d[0] / 1000);
          if (seen.has(t)) return false;
          seen.add(t);
          return true;
        });

        // Sort by time
        allData.sort((a, b) => a[0] - b[0]);

        if (chartType === "line") {
          const points = allData.map((d) => ({ time: Math.floor(d[0] / 1000), value: parseFloat(d[4]) }));
          activeSeries.setData(points);
        } else {
          const candles = allData.map((d) => ({
            time: Math.floor(d[0] / 1000),
            open: parseFloat(d[1]), high: parseFloat(d[2]),
            low: parseFloat(d[3]), close: parseFloat(d[4]),
          }));
          activeSeries.setData(candles);
        }

        // Volume data
        if (volumeSeriesRef.current) {
          const volumes = allData.map((d) => ({
            time: Math.floor(d[0] / 1000),
            value: parseFloat(d[5]),
            color: parseFloat(d[4]) >= parseFloat(d[1]) ? "#22c55e40" : "#ef444440",
          }));
          volumeSeriesRef.current.setData(volumes);
        }

        chartInstance.current.timeScale().fitContent();
        setTimeout(() => {
          if (chartInstance.current) {
            chartInstance.current.timeScale().scrollToRealTime();
          }
        }, 50);

      } catch (e) {
        console.error("Chart fetch error:", e);
      }
    };

    fetchKlines();
  }, [coin, activeInterval, chartReady, chartType]);

  useEffect(() => {
    if (!coin) return;
    if (wsRef.current) wsRef.current.close();

    // Fetch initial price
    fetch("https://api.binance.com/api/v3/ticker/24hr?symbol=" + coin.symbol)
      .then((r) => r.json())
      .then((d) => {
        setLivePrice(parseFloat(d.lastPrice));
        setChange24h(parseFloat(d.priceChangePercent));
      })
      .catch(() => {});

    // Ticker WebSocket — only updates price display, never touches chart
    const tickerWs = new WebSocket("wss://stream.binance.com:9443/ws/" + coin.symbol.toLowerCase() + "@ticker");
    tickerWs.onmessage = (e) => {
      const d = JSON.parse(e.data);
      setLivePrice(parseFloat(d.c));
      setChange24h(parseFloat(d.P));
    };

    // Kline WebSocket — updates chart with correct interval
    const klineWs = new WebSocket("wss://stream.binance.com:9443/ws/" + coin.symbol.toLowerCase() + "@kline_" + activeInterval);
    klineWs.onmessage = (e) => {
      const d = JSON.parse(e.data);
      const k = d.k;
      const time = Math.floor(k.t / 1000);
      const close = parseFloat(k.c);
      const open = parseFloat(k.o);
      const high = parseFloat(k.h);
      const low = parseFloat(k.l);
      const volume = parseFloat(k.v);
      if (lineSeriesRef.current) {
        try { lineSeriesRef.current.update({ time, value: close }); } catch (_) {}
      }
      if (candleSeriesRef.current) {
        try { candleSeriesRef.current.update({ time, open, high, low, close }); } catch (_) {}
      }
      if (volumeSeriesRef.current) {
        try {
          volumeSeriesRef.current.update({
            time,
            value: volume,
            color: close >= open ? "#22c55e40" : "#ef444440",
          });
        } catch (_) {}
      }
      if (chartInstance.current) chartInstance.current.timeScale().scrollToRealTime();
    };

    wsRef.current = tickerWs;
    return () => {
      tickerWs.close();
      klineWs.close();
    };
  }, [coin, activeInterval]);

  if (!coin) {
    return <div className="pt-32 text-center text-[var(--text-tertiary)] font-mono">Coin not found.</div>;
  }

  const isPositive = (change24h || 0) >= 0;
  const md = marketData?.market_data;

  const stats = [
    { label: "Market Cap",         value: formatNumber(md?.market_cap?.usd) },
    { label: "24h Volume",         value: formatNumber(md?.total_volume?.usd) },
    { label: "24h High",           value: formatPrice(md?.high_24h?.usd) },
    { label: "24h Low",            value: formatPrice(md?.low_24h?.usd) },
    { label: "Circulating Supply", value: md?.circulating_supply ? md.circulating_supply.toLocaleString() + " " + coin.ticker : "N/A" },
    { label: "Total Supply",       value: md?.total_supply ? md.total_supply.toLocaleString() + " " + coin.ticker : "N/A" },
    { label: "All Time High",      value: formatPrice(md?.ath?.usd) },
    { label: "ATH Change",         value: md?.ath_change_percentage?.usd ? md.ath_change_percentage.usd.toFixed(1) + "%" : "N/A" },
  ];

  const ChartControls = () => (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="flex border border-[var(--border-soft)] overflow-hidden">
        <button onClick={() => setChartType("line")} className={"px-3 py-1 text-xs font-mono uppercase tracking-wide transition " + (chartType === "line" ? "bg-yellow-400 text-black" : "text-[var(--text-tertiary)] hover:text-yellow-400")}>Line</button>
        <button onClick={() => setChartType("candle")} className={"px-3 py-1 text-xs font-mono uppercase tracking-wide transition " + (chartType === "candle" ? "bg-yellow-400 text-black" : "text-[var(--text-tertiary)] hover:text-yellow-400")}>Candle</button>
      </div>
      <div className="flex gap-1">
        {INTERVALS.map((i) => (
          <button key={i.value} onClick={() => setActiveInterval(i.value)} className={"px-2 py-1 text-xs font-mono uppercase tracking-wide transition " + (activeInterval === i.value ? "bg-yellow-400 text-black" : "border border-[var(--border-soft)] text-[var(--text-tertiary)] hover:border-yellow-400 hover:text-yellow-400")}>{i.label}</button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="pt-10 pb-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
          <div className="flex items-center gap-4">
            {marketData?.image?.large && (
              <img src={marketData.image.large} alt={coin.name} className="w-10 h-10 md:w-12 md:h-12" />
            )}
            <div>
              <div className="flex items-center gap-2 flex-wrap">
                <h1 className="font-display font-bold text-2xl md:text-4xl text-[var(--text-primary)]">{coin.name}</h1>
                <span className="font-mono text-xs text-[var(--text-tertiary)] bg-[var(--bg-elevated)] px-2 py-1">{coin.ticker}</span>
                {md?.market_cap_rank && (
                  <span className="font-mono text-xs text-yellow-400 border border-yellow-400/30 px-2 py-1">{"#" + md.market_cap_rank}</span>
                )}
              </div>
              <div className="flex items-center gap-3 mt-1">
                <span className="font-display font-bold text-2xl md:text-3xl text-[var(--text-primary)]">{formatPrice(livePrice)}</span>
                {change24h !== null && (
                  <span className={"flex items-center gap-1 font-mono text-sm font-bold " + (isPositive ? "text-green-400" : "text-red-400")}>
                    {isPositive ? <ArrowUpRight className="w-4 h-4" /> : <ArrowDownRight className="w-4 h-4" />}
                    {Math.abs(change24h).toFixed(2) + "%"}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ONE layout for both mobile and desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-8">

          {/* Chart — full width on mobile, 8 cols on desktop */}
          <div className="col-span-1 lg:col-span-8 bg-[var(--bg-panel)] border border-[var(--border-soft)] p-4">
            <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
              <h2 className="font-display font-bold text-lg text-[var(--text-primary)]">{coin.name + " Price Chart"}</h2>
              <ChartControls />
            </div>
            <div ref={chartRef} style={{ width: "100%", height: "380px" }} />
            <MarketStats globalData={globalData} fearGreed={fearGreed} />
          </div>

          {/* Stats + Converter — full width on mobile, 4 cols on desktop */}
          <div className="col-span-1 lg:col-span-4 flex flex-col gap-2">
            {stats.map((s) => (
              <div key={s.label} className="bg-[var(--bg-panel)] border border-[var(--border-soft)] px-4 py-3 flex items-center justify-between">
                <div className="text-xs font-mono uppercase tracking-widest text-[var(--text-tertiary)]">{s.label}</div>
                <div className="font-display font-bold text-[var(--text-primary)] text-sm text-right">{s.value}</div>
              </div>
            ))}
            <div className="bg-[var(--bg-panel)] border border-[var(--border-soft)] p-4">
              <div className="text-xs font-mono uppercase tracking-widest text-[var(--text-tertiary)] mb-3">{coin.ticker + " Converter"}</div>
              <MiniConverter ticker={coin.ticker} price={livePrice} />
            </div>
          </div>

        </div>

        {/* About */}
        {marketData?.description?.en && (
          <div className="bg-[var(--bg-panel)] border border-[var(--border-soft)] p-6 mb-8">
            <h2 className="font-display font-bold text-xl text-[var(--text-primary)] mb-4">{"About " + coin.name}</h2>
            <p className="text-[var(--text-secondary)] leading-relaxed text-sm">
              {marketData.description.en.replace(/<[^>]+>/g, "")}
            </p>
          </div>
        )}

        {/* Related News */}
        {news.length > 0 && (
          <div className="mb-8">
            <h2 className="font-display font-bold text-2xl text-[var(--text-primary)] mb-6">
              <span className="text-yellow-400">/</span>
              {" Latest " + coin.name + " News"}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {news.map((n) => (
                <Link key={n.id} to={"/news/" + n.id} className="block bg-[var(--bg-panel)] border border-[var(--border-soft)] hover:border-yellow-400/40 transition p-5 group">
                  {n.image_url && <img src={n.image_url} alt={n.title} className="w-full h-32 object-cover mb-4" />}
                  <h3 className="font-display font-bold text-[var(--text-primary)] group-hover:text-yellow-400 transition">{n.title}</h3>
                  <p className="mt-2 text-sm text-[var(--text-secondary)] line-clamp-2">{n.excerpt}</p>
                </Link>
              ))}
            </div>
          </div>
        )}

        <BinanceCTA name={coin.name} />

      </div>
    </div>
  );
}